// Local-timezone date/time formatters for UTC ISO strings returned by the API.
// The API outputs UTC; these helpers render in the user's local timezone.

function pad(n) {
  return String(n).padStart(2, '0')
}

function parse(value) {
  if (!value) return null
  const d = value instanceof Date ? value : new Date(value)
  return Number.isNaN(d.getTime()) ? null : d
}

export function toLocalDate(value) {
  const d = parse(value)
  if (!d) return ''
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`
}

export function toLocalTime(value) {
  const d = parse(value)
  if (!d) return ''
  return `${pad(d.getHours())}:${pad(d.getMinutes())}`
}

export function toLocalDateTime(value) {
  const d = parse(value)
  if (!d) return ''
  return `${toLocalDate(d)} ${toLocalTime(d)}`
}
